<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="6">
                    <input type="text" v-model="filter" placeholder="Search" class="form-control"/>
                </CCol>
                <CCol sm="4">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataTipeFilter" class="form-control" v-model="tipeFilter" placeholder="Pilih Tipe"></model-select>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="modalDetail"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div :style="flagModal==true&&'background-color:lightgrey;opacity:0.2'" class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Detail Data</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalDetail = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div :style="flagModal==true&&'background-color:lightgrey;opacity:0.2'" style="padding-right:20px;padding-left:20px">
                    <CRow class="mt-2 mb-5">
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="3">
                                    Nama Pegawai
                                </CCol>
                                <CCol sm="1 text-right">
                                    :
                                </CCol>
                                <CCol sm="8">
                                    <span class="font-weight-bold">{{details.nama}}</span>
                                </CCol>
                            </CRow>
                            <CRow class="mt-2">
                                <CCol sm="3">
                                    NIP
                                </CCol>
                                <CCol sm="1 text-right">
                                    :
                                </CCol>
                                <CCol sm="8">
                                    {{details.nik}}
                                </CCol>
                            </CRow>
                            <CRow class="mt-2">
                                <CCol sm="3">
                                    Nama Atasan
                                </CCol>
                                <CCol sm="1 text-right">
                                    :
                                </CCol>
                                <CCol sm="8">
                                    {{details.namaAtasan}}
                                </CCol>
                            </CRow>
                            <CRow class="mt-2">
                                <CCol sm="3">
                                    Tipe
                                </CCol>
                                <CCol sm="1 text-right">
                                    :
                                </CCol>
                                <CCol sm="8">
                                    <span class="font-weight-bold">{{details.tipe}}</span>
                                </CCol>
                            </CRow>
                            <CRow v-if="details.idTipe != '2'" class="mt-2">
                                <CCol sm="3">
                                    Kronologis
                                </CCol>
                                <CCol sm="1 text-right">
                                    :
                                </CCol>
                                <CCol sm="8">
                                    <span class="font-weight-bold">{{details.kronologis}}</span>
                                </CCol>
                            </CRow>
                            <CRow v-if="details.idStatus == '100'" class="mt-2">
                                <CCol sm="3">
                                    Lokasi Tes
                                </CCol>
                                <CCol sm="1 text-right">
                                    :
                                </CCol>
                                <CCol sm="8">
                                    {{details.lokasi}} sampai {{details.tanggalExpired}}
                                </CCol>
                            </CRow>
                            <CRow v-if="details.idStatus == '100' || details.idStatus == '98'" class="mt-2">
                                <CCol sm="3">
                                    <span v-if="details.idStatus == '100'">Approve</span><span v-if="details.idStatus == '98'">Rejected</span> by
                                </CCol>
                                <CCol sm="1 text-right">
                                    :
                                </CCol>
                                <CCol sm="8">
                                    {{details.namaPegawaiApprove}} pada {{details.tanggalApprove}}
                                </CCol>
                            </CRow>
                            <CRow v-if="details.idStatus == '100' || details.idStatus == '98'" class="mt-2">
                                <CCol sm="3">
                                    Keterangan
                                </CCol>
                                <CCol sm="1 text-right">
                                    :
                                </CCol>
                                <CCol sm="8">
                                    "{{details.keteranganApprove}}"
                                </CCol>
                            </CRow>
                            <CRow class="mt-2">
                                <CCol sm="3">
                                    Status
                                </CCol>
                                <CCol sm="1 text-right">
                                    :
                                </CCol>
                                <CCol sm="8">
                                    <span class="font-weight-bold" :style="'color:'+details.colorStatus">{{details.status}}</span>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow class="mt-5" style="padding-bottom:40px">
                        <CCol v-if="details.idStatus == '2'" sm="6"></CCol>
                        <CCol v-if="details.idStatus != '2'" sm="12"></CCol>
                        <CCol v-if="details.idStatus == '2'" sm="3">
                            <CButton style="width:100%!important" @click="modalReject = true" class="btn btn-danger">Reject</CButton>
                        </CCol>
                        <CCol v-if="details.idStatus == '2'" sm="3">
                            <CButton style="width:100%!important" @click="modalApprove = true" class="btn btn-primary">Approve</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalReject"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Reject</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalReject = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow class="mt-2 mb-5">
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="12">
                                    <label>Masukan Alasan</label>
                                </CCol>
                            </CRow>
                            <CRow class="mt-1">
                                <CCol sm="12">
                                    <textarea v-model="inputKeterangan" class="form-control" placeholder="Masukan Alasan" />
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow v-if="errAlert != ''" class="mt-3">
                        <CCol sm="12">
                            <span class="text-danger">{{errAlert}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-5" style="padding-bottom:40px">
                        <CCol sm="6"></CCol>
                        <CCol sm="3">
                            <CButton style="width:100%!important" @click="modalReject = false" class="btn-cancel">Back</CButton>
                        </CCol>
                        <CCol sm="3">
                        <CButton style="width:100%!important" @click="saveReject()" class="btn btn-danger">Reject</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalApprove"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Approve</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalApprove = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow class="mt-2 mb-5">
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="12">
                                    <label>Masukan lokasi tes yang direkomendasikan</label>
                                </CCol>
                            </CRow>
                            <CRow class="mt-1">
                                <CCol sm="12">
                                    <textarea v-model="inputLokasi" class="form-control" placeholder="Masukan Lokasi" />
                                </CCol>
                            </CRow>
                            <CRow class="mt-3">
                                <CCol sm="12">
                                    <label>Tanggal Batas Tes</label>
                                </CCol>
                            </CRow>
                            <CRow class="mt-1">
                                <CCol sm="12">
                                    <input :min="getDateNow()" type="date" v-model="inputTanggal" class="form-control" />
                                </CCol>
                            </CRow>
                            <CRow class="mt-3">
                                <CCol sm="12">
                                    <label>Masukan keterangan</label>
                                </CCol>
                            </CRow>
                            <CRow class="mt-1">
                                <CCol sm="12">
                                    <textarea v-model="inputKeterangan" class="form-control" placeholder="Masukan Keterangan" />
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow v-if="errAlert != ''" class="mt-3">
                        <CCol sm="12">
                            <span class="text-danger">{{errAlert}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-5" style="padding-bottom:40px">
                        <CCol sm="6"></CCol>
                        <CCol sm="3">
                            <CButton style="width:100%!important" @click="modalApprove = false" class="btn-cancel">Back</CButton>
                        </CCol>
                        <CCol sm="3">
                            <CButton style="width:100%!important" @click="saveApprove()" class="btn btn-primary">Approve</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableApprovalTes'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
export default {
    components: {
        Tables,
        ModelSelect
    },
    data() {
        return {
            success: true,
            itemHeight: 39,

            filter: '',
            dataTipeFilter: [],
            tipeFilter: {
                value: '',
                text: ''
            },

            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['Nama Pegawai', 'Nama Atasan', 'Tipe', 'Keterangan', 'Status', 'Action'],
            dataTd: ['nama', 'namaAtasan', 'tipe', 'keterangan', 'status', 'action'],
            styleTable: ['125px', '125px', '100px', '200px', '100px', '100px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,
            
            // datas
            datas: [],
            details: [],

            //error
            errorMessage: '',
            modalDetail: false,
            modalReject: false,
            modalApprove: false,
            flagModal: false,

            inputKeterangan: '',
            inputTanggal: '',
            inputLokasi: '',
            errAlert: '',
            flagSearch: false,
            dateNow: new Date()
        }
    },
    computed: {
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        modalReject() {
            this.checkModal()
            if(this.modalReject == false) {
                this.errAlert = ''
            }
        },
        modalApprove() {
            this.checkModal()
            if(this.modalApprove == false) {
                this.errAlert = ''
            }
        },
        modalDetail() {
            if(this.modalDetail == false) {
                this.inputKeterangan = ''
                this.inputLokasi = ''
                this.inputTanggal = ''
                this.details = []
                this.errAlert = ''
            }
        },
        tipeFilter() {
            this.flagSearch = true
        },
        filter() {
            this.flagSearch = true
        }
    },
    methods: {
        getDateNow() {
            let now = this.dateNow
            let tanggal = now.getDate()
            let bulan = now.getMonth()+1
            if(bulan != 10 && bulan != 11 && bulan != 12) {
                bulan = '0'+ bulan
            }
            let tahun = now.getFullYear()
            return tahun + '-' + bulan + '-' + tanggal
        },
        checkModal() {
            if(this.modalReject == true || this.modalApprove == true) {
                this.flagModal = true
            } else {
                this.flagModal = false
            }
        },
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.namaKantor.toLowerCase() < b.namaKantor.toLowerCase()) {
                        return -1
                    }
                    if (a.namaKantor.toLowerCase() > b.namaKantor.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.tanggal.toLowerCase() < b.tanggal.toLowerCase()) {
                        return -1
                    }
                    if (a.tanggal.toLowerCase() > b.tanggal.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.jam.toLowerCase() < b.jam.toLowerCase()) {
                        return -1
                    }
                    if (a.jam.toLowerCase() > b.jam.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let page = this.page

            let payload = {
                filter: this.filter,
                limit: limit,
                pageIn: page,
                tipe: this.tipeFilter.value
            }
            DataApi.post("rta/request/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.filter = ''
            this.tipeFilter.value = ''
            this.tipeFilter.text = ''
            this.flagSearch = true
            this.getDataTipeFilter()
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        /**
         * ADD DATA
         */
        saveReject() {
            if(this.inputKeterangan == '') {
                this.errAlert = '*Harap mengisi data terlebih dahulu'
            } else {
                this.errAlert = ''
                this.goSave('R')
            }
        },
        saveApprove() {
            if(this.inputKeterangan == '' || this.inputTanggal == '' || this.inputLokasi == '') {
                this.errAlert = '*Harap mengisi data terlebih dahulu'
            } else {
                this.errAlert = ''
                this.goSave('A')
            }
        },
        goSave(vals) {
            this.$store.state.loadingScreen = true
            let keterangan = ''
            let lokasi = ''
            let tanggal = ''
            let unix = this.details.unix
            if(vals == 'A') {
                keterangan = this.inputKeterangan
                lokasi = this.inputLokasi
                tanggal = this.inputTanggal
            } else {
                keterangan = this.inputKeterangan
            }
            let payload = {
                keteranganApprove: keterangan,
                lokasi: lokasi,
                status: vals,
                tangalExpired: tanggal,
                unix: unix
            }
            DataApi.post("rta/request/approve", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.modalReject = false
                this.modalApprove = false
                this.getData()
                this.modalDetail = false            
                this.loading = false
                this.currentAlertCounter = 7
                this.$store.state.loadingScreen = false
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            this.details = this.datas[value]
            this.modalDetail = true
        },
        getDataTipeFilter() {
            this.dataTipeFilter = [
                { value: '', text: 'Semua Tipe' },
                { value: '1', text: 'Kontak Erat' },
                { value: '2', text: 'Reaktif' },
            ]
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataTipeFilter()
    },
}
</script>
<style scoped>
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 64px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 32px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 40px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: scroll;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
</style>